export const app = {
  frontversion: '2.7.13',
  manualConsole: '1.2',
  boxversion: '25.3.4'
}
